export function getDataFirebase(param: any, fn: any) {
  const result = [];
  param.forEach((doc) => {
    const data = fn(doc.data());
    result.push(data);
  });
  return result;
}
